import { Button } from '@/components/button/button'
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/card/card'

import { cn } from '@/lib/utils'

import { useConfirmWithoutSubscriptionCard } from './use-confirm-without-subscription-card'

export interface ConfirmWithoutSubscriptionCardProps {
  onClickCancelButton: VoidFunction
}

export const ConfirmWithoutSubscriptionCard = ({ onClickCancelButton }: ConfirmWithoutSubscriptionCardProps) => {
  const { isLoadingDeleteButton, isDisabledCancelButton, handleClickDeleteButton } = useConfirmWithoutSubscriptionCard()

  return (
    <Card className={cn('max-w-[500px]')}>
      <CardHeader>
        <CardTitle>Account Deletion is a Permanent Action</CardTitle>
      </CardHeader>
      <CardContent>
        <p className={cn('text-sm font-normal text-muted-foreground')}>
          Please note that account deletion is a permanent action and once your account is deleted, all the registered
          members, applicants, and cases will be permanently deleted and cannot be restored.
        </p>
      </CardContent>
      <CardFooter className={cn('flex gap-x-3')}>
        <Button
          type="button"
          variant="destructive"
          className={cn('w-2/3')}
          loading={isLoadingDeleteButton}
          onClick={handleClickDeleteButton}
        >
          Permanently delete
        </Button>
        <Button
          type="button"
          variant="secondary"
          className={cn('w-1/3')}
          disabled={isDisabledCancelButton}
          onClick={onClickCancelButton}
        >
          Cancel
        </Button>
      </CardFooter>
    </Card>
  )
}
